<script setup lang="ts">
import { Step } from '@/models'

const props = defineProps<{
    steps: Array<Step>
    currentStep: Step
}>()

const itemClass = (itemStep: Step) => {
    const base = ['my-1 @md:my-3 pb-1 border-l-2 pl-2 @md:border-l-0 @md:border-b-2 @md:border-b-4 flex-grow-1']

    if (itemStep === props.currentStep) {
        // active step
        base.push('border-white')
    } else {
        base.push('text-cupra-white-off border-cupra-white-off')
    }

    return base
}

const labeledSteps: { [key in Step]: string } = {
    [Step.postalCode]: 'Vul je postcode in',
    [Step.location]: 'Kies een locatie',
    [Step.userData]: 'Vul je gegevens in',
    [Step.confirmation]: 'Klaar',
    [Step.error]: 'Fout',
}
const stepLabel = (step: Step) => labeledSteps[step]
</script>

<template>
    <ol class="flex w-full list-inside list-decimal flex-col text-sm @md:flex-row @md:gap-2 @lg:text-base">
        <li
            v-for="(step, ix) in steps"
            :key="ix"
            :class="itemClass(step)"
        >
            {{ stepLabel(step) }}
        </li>
    </ol>
</template>
